import { useContext, useEffect } from "react";
import { yupResolver } from "@hookform/resolvers/yup";
import { useSelector } from "react-redux";
import { useForm } from "react-hook-form";
import { isEmpty } from "lodash";

import { HiOutlinePlusSm, HiNewspaper, HiOutlineX } from "react-icons/hi";

import { newsAdminContext } from "../../../../context/AdminContext/NewsAdminContext/NewsAdminContext";

import {
  editNewsAdminValidation,
  addNewsAdminValidation,
} from "../../../../utils/validation/validation";
import { areYouSureMessage } from "../../../../utils/toastMessage/toastMessage";

import ValidationErrorMessage from "../../../../helpers/ValidationErrorMessage/ValidationErrorMessage";
import SiteTitle from "../../../../helpers/SiteTitle/SiteTitle";
import MenuUi from "../../../../helpers/MenuUi/MenuUi";
import { HiMiniStar } from "react-icons/hi2";

const AdminDashboardNews = () => {
  const userInfo = useSelector((state) => state.userInfo);

  const {
    isOpenAddModal,
    setIsOpenAddModal,
    getNewsItems,
    newsId,
    setAdminUser,
    handleCreateNewsAdmin,
    handleGetNewsAdmin,
    handleEditNewsAdmin,
    handleCloseEditModal,
    handleOpenEditModal,
    handleChangeActivationNews,
    handleDeleteNews,
  } = useContext(newsAdminContext);

  useEffect(() => {
    handleGetNewsAdmin();
  }, []);

  //* Add New Validation
  const {
    register: registerAddNews,
    handleSubmit: handleSubmitAddNews,
    reset,
    watch: watchAddNews,
    formState: { errors: errorsAddNews },
  } = useForm({
    resolver: yupResolver(addNewsAdminValidation),
  });

  //* Edit News Validation
  const {
    register: registerEditNews,
    handleSubmit: handleSubmitEditNews,
    setValue,
    watch: watchEditNews,
    formState: { errors: errorsEditNews },
  } = useForm({
    resolver: yupResolver(editNewsAdminValidation),
  });

  //* Table Header
  const tableHeader = [
    { id: 1, title: "#" },
    { id: 2, title: "موضوع اخبار" },
    { id: 3, title: "متن اخبار" },
    { id: 4, title: "عملیات" },
  ];

  return (
    <>
      <SiteTitle title="اخبار" />
      <div className="mr-auto w-full h-full">
        <div className="flex h-screen justify-end items-center rounded-xl bg-mainBackground">
          <div
            className="rounded-xl flex flex-col h-full w-full relative
             animate__animated animate__fadeIn animate__fast"
          >
            {/* Menu */}
            <MenuUi className={"top-2"} />
            <div className="w-full flex flex-col justify-center items-center">
              {/* Add Product Button */}
              <span className="flex w-full justify-end mt-8 mb-2 text-white ml-4">
                <button
                  onClick={() => {
                    reset();
                    setIsOpenAddModal(true);
                  }}
                  className="flex items-center bg-green-500 hover:bg-green-600
                  rounded-full px-2 lg:py-2 py-1 font-bold lg:text-sm text-xs"
                >
                  اضافه کردن اخبار
                  <HiOutlinePlusSm size={20} />
                </button>
              </span>
              {isEmpty(getNewsItems) ? (
                <>
                  <span
                    className="mr-auto w-full py-3 mt-10
                    text-slate-200 text-xl flex flex-col
                    justify-center items-center absolute top-[50%]"
                  >
                    <span>
                      <HiNewspaper size={60} className="mb-2" />
                    </span>
                    <p>اخباری وجود ندارد</p>
                  </span>
                </>
              ) : (
                <>
                  <div className="w-full flex justify-end items-center">
                    {/* Table */}
                    <table className="w-full 2xl:w-[95%] xl:w-[93%] lg:w-[90%] h-full">
                      <thead className="text-sm font-medium text-slate-200 border-b-[1px] border-boxColor">
                        <tr>
                          {tableHeader?.map((_item) => (
                            <th key={_item?.id} className="py-3">
                              <div>{_item?.title}</div>
                            </th>
                          ))}
                        </tr>
                      </thead>
                      <tbody className="text-lg divide-y divide-boxColor w-full h-full overflow-y-scroll">
                        {getNewsItems.map((_item, index) => (
                          <tr
                            key={_item?.id}
                            className="hover:bg-boxColor w-full h-16 relative
                            text-center lg:text-sm text-xs font-medium tracking-wide text-slate-200"
                          >
                            {/* Number */}
                            <td className="px-3">
                              <div className="flex justify-center text-center lg:text-sm text-xs font-medium text-slate-200">
                                {index + 1}
                              </div>
                            </td>
                            {/* Title */}
                            <td>
                              <span>{_item.title}</span>
                            </td>
                            {/* Description */}
                            <td className="flex justify-center items-center h-full">
                              <span className="flex justify-center w-44">
                                <p className="truncate ... w-full">
                                  {_item.description}
                                </p>
                              </span>
                            </td>
                            {/* Activation */}
                            <td className="py-2">
                              <div className="flex justify-center text-gray-400 lg:text-sm text-xs">
                                <p className="tracking-wider">
                                  {_item.isShow ? (
                                    <span
                                      onClick={() =>
                                        handleChangeActivationNews(
                                          _item.id,
                                          false
                                        )
                                      }
                                      className="px-2.5 rounded-full text-black cursor-pointer"
                                    >
                                      <HiMiniStar size={20} fill="#facc15" />
                                    </span>
                                  ) : (
                                    <span
                                      onClick={() =>
                                        handleChangeActivationNews(
                                          _item.id,
                                          true
                                        )
                                      }
                                      className="px-2.5 rounded-full text-black cursor-pointer"
                                    >
                                      <HiMiniStar size={20} fill="#fff    " />
                                    </span>
                                  )}
                                </p>
                              </div>
                            </td>
                            {/* Buttons */}
                            <td className="px-3">
                              <span
                                className="flex lg:flex-row-reverse flex-col 
                                 justify-center items-center text-gray-950 lg:text-sm
                                  text-xs font-bold lg:space-x-2 lg:space-y-0 space-y-2 space-x-0"
                              >
                                {/* Delete Button */}
                                <span>
                                  <button
                                    onClick={() =>
                                      areYouSureMessage(
                                        () => handleDeleteNews(_item.id),
                                        `آیا از حذف ${_item.title} مطمئنید؟`
                                      )
                                    }
                                    className="bg-red-600 hover:bg-red-700 text-white
                           tracking-wider lg:px-2.5 px-1.5 lg:py-1 py-0.5 rounded-full"
                                  >
                                    حذف
                                  </button>
                                </span>
                                {/* Edit Button */}
                                <span>
                                  <button
                                    onClick={() =>
                                      handleOpenEditModal(_item, setValue)
                                    }
                                    className="bg-yellow-500 hover:bg-yellow-600 text-white
                          tracking-wider lg:px-2.5 px-1.5 lg:py-1 py-0.5 rounded-full"
                                  >
                                    ویرایش
                                  </button>
                                </span>
                              </span>
                            </td>
                          </tr>
                        ))}
                      </tbody>
                    </table>
                  </div>
                </>
              )}
            </div>
            {/* Add Modal */}
            {isOpenAddModal && (
              <div
                className="flex bg-black bg-opacity-40 fixed
              inset-0 items-center w-full z-50 mr-auto h-screen
              animate__animated animate__fadeIn animate__fast"
              >
                <div
                  className="flex flex-col absolute top-20 left-0 right-0 
                  w-11/12 sm:w-5/6 lg:w-12/12 max-w-2xl mx-auto rounded-lg 
                  border-2 border-modalColor"
                >
                  <div className="flex flex-row justify-between p-5 bg-modalColor">
                    {/* Title - Close Icon */}
                    <span className="flex justify-between w-full text-gray-200">
                      {/* Title */}
                      <span>
                        <p className="font-semibold">اضافه کردن اخبار</p>
                      </span>
                      {/* Close Icon */}
                      <span>
                        <HiOutlineX
                          size={25}
                          onClick={() => setIsOpenAddModal(false)}
                          className="cursor-pointer"
                        />
                      </span>
                    </span>
                  </div>
                  <span className="border-b-2 border-headerLineModal" />
                  {/* Inputs */}
                  <div className="w-full px-6 py-5 bg-modalColor">
                    <form onSubmit={handleSubmitAddNews(handleCreateNewsAdmin)}>
                      <div className="flex flex-col w-full">
                        {/* Title */}
                        <span>
                          <label
                            htmlFor="title"
                            className="block mb-2 mr-2.5 text-sm font-medium text-gray-200"
                          >
                            موضوع اخبار
                          </label>
                          <input
                            type="text"
                            name="title"
                            placeholder="موضوع اخبار"
                            autoComplete="off"
                            {...registerAddNews("title")}
                            className="p-2 mb-2 bg-transparent border-2 border-slate-600 w-full
                            rounded-md focus:right-0 focus:outline-none tracking-wide
                            placeholder-gray-600 bg-zinc-900 text-gray-400
                            focus:border-gray-200 focus:text-gray-200"
                          />
                          <span>
                            <ValidationErrorMessage
                              message={errorsAddNews.title?.message}
                            />
                          </span>
                        </span>
                        {/* Description */}
                        <span>
                          <label
                            htmlFor="description"
                            className="block mb-2 mr-2.5 text-sm font-medium text-gray-200"
                          >
                            متن اخبار
                          </label>
                          <textarea
                            type="text"
                            name="description"
                            placeholder="متن اخبار"
                            autoComplete="off"
                            {...registerAddNews("description")}
                            className="p-2 mb-2 bg-transparent border-2 border-slate-600 w-full
rounded-md focus:right-0 focus:outline-none tracking-wide
placeholder-gray-600 bg-zinc-900 text-gray-400
focus:border-gray-200 focus:text-gray-200"
                          />
                          <span>
                            <ValidationErrorMessage
                              message={errorsAddNews.description?.message}
                            />
                          </span>
                        </span>
                        {/* Is Show News */}
                        <span>
                          <label
                            htmlFor="isShow"
                            className="block mb-2 mr-2.5 text-sm font-medium text-gray-200"
                          >
                            نمایش/عدم نمایش
                          </label>
                          <select
                            name="isShow"
                            {...registerAddNews("isShow")}
                            value={watchAddNews("isShow") || ""}
                            className="p-2 mb-2 bg-transparent border-2 border-slate-600 w-full
                            rounded-md focus:right-0 focus:outline-none tracking-wide
                            placeholder-gray-600 bg-zinc-900 text-gray-400
                            focus:border-gray-200 focus:text-gray-200"
                          >
                            <option
                              className="text-gray-200 p-1"
                              hidden
                              value=""
                            >
                              نمایش/عدم نمایش
                            </option>
                            <option className="text-gray-200 p-1" value={true}>
                              نمایش
                            </option>
                            <option className="text-gray-200 p-1" value={false}>
                              عدم نمایش
                            </option>
                          </select>
                          <span>
                            <ValidationErrorMessage
                              message={errorsAddNews.isShow?.message}
                            />
                          </span>
                        </span>
                        {/* User Id */}
                        <span>{setAdminUser(userInfo[0]?.id)}</span>
                      </div>
                      {/* Button */}
                      <div className="flex items-center justify-end p-5 w-full">
                        <button
                          type="submit"
                          className="px-4 py-1.5 text-white text-sm font-medium bg-green-500 hover:bg-green-600 rounded"
                        >
                          اضافه کردن
                        </button>
                      </div>
                    </form>
                  </div>
                </div>
              </div>
            )}
            {/* Edit Modal */}
            {newsId && (
              <div
                className="flex bg-black bg-opacity-40 fixed
                inset-0 items-center w-full z-50 mr-auto h-screen
                animate__animated animate__fadeIn animate__fast"
              >
                <div
                  className="flex flex-col absolute top-20 left-0 right-0 
                  w-11/12 sm:w-5/6 lg:w-12/12 max-w-2xl mx-auto rounded-lg 
                  border-2 border-modalColor"
                >
                  <div className="flex flex-row justify-between p-5 bg-modalColor">
                    {/* Title - Close Icon */}
                    <span className="flex justify-between w-full text-gray-200">
                      {/* Title */}
                      <span>
                        <p className="font-semibold">ویرایش کردن اخبار</p>
                      </span>
                      {/* Close Icon */}
                      <span>
                        <HiOutlineX
                          size={25}
                          onClick={handleCloseEditModal}
                          className="cursor-pointer"
                        />
                      </span>
                    </span>
                  </div>
                  <span className="border-b-2 border-headerLineModal" />
                  {/* Inputs */}
                  <div className="w-full px-6 py-5 bg-modalColor">
                    <form onSubmit={handleSubmitEditNews(handleEditNewsAdmin)}>
                      <div className="flex flex-col w-full">
                        {/* Title */}
                        <span>
                          <label
                            htmlFor="title"
                            className="block mb-2 mr-2.5 text-sm font-medium text-gray-200"
                          >
                            موضوع اخبار
                          </label>
                          <input
                            type="text"
                            name="title"
                            placeholder="موضوع اخبار"
                            autoComplete="off"
                            {...registerEditNews("title")}
                            className="p-2 mb-2 bg-transparent border-2 border-slate-600 w-full
                            rounded-md focus:right-0 focus:outline-none tracking-wide
                            placeholder-gray-600 bg-zinc-900 text-gray-400
                            focus:border-gray-200 focus:text-gray-200"
                          />
                          <span>
                            <ValidationErrorMessage
                              message={errorsEditNews.title?.message}
                            />
                          </span>
                        </span>
                        {/* Description */}
                        <span>
                          <label
                            htmlFor="description"
                            className="block mb-2 mr-2.5 text-sm font-medium text-gray-200"
                          >
                            متن اخبار
                          </label>
                          <textarea
                            type="text"
                            name="description"
                            placeholder="متن اخبار"
                            autoComplete="off"
                            {...registerEditNews("description")}
                            className="p-2 mb-2 bg-transparent border-2 border-slate-600 w-full
                            rounded-md focus:right-0 focus:outline-none tracking-wide
                            placeholder-gray-600 bg-zinc-900 text-gray-400
                            focus:border-gray-200 focus:text-gray-200"
                          />
                          <span>
                            <ValidationErrorMessage
                              message={errorsEditNews.description?.message}
                            />
                          </span>
                        </span>
                        {/* Is Show News */}
                        <span>
                          <label
                            htmlFor="isShow"
                            className="block mb-2 mr-2.5 text-sm font-medium text-gray-200"
                          >
                            نمایش/عدم نمایش
                          </label>
                          <select
                            name="isShow"
                            {...registerEditNews("isShow")}
                            value={watchEditNews("isShow") || ""}
                            className="p-2 mb-2 bg-transparent border-2 border-slate-600 w-full
                            rounded-md focus:right-0 focus:outline-none tracking-wide
                            placeholder-gray-600 bg-zinc-900 text-gray-400
                            focus:border-gray-200 focus:text-gray-200"
                          >
                            <option
                              className="text-gray-200 p-1"
                              hidden
                              value=""
                            >
                              نمایش/عدم نمایش
                            </option>
                            <option className="text-gray-200 p-1" value={true}>
                              نمایش
                            </option>
                            <option className="text-gray-200 p-1" value={false}>
                              عدم نمایش
                            </option>
                          </select>
                          <span>
                            <ValidationErrorMessage
                              message={errorsEditNews.isShow?.message}
                            />
                          </span>
                        </span>
                      </div>
                      {/* Button */}
                      <div className="flex items-center justify-end p-5 w-full">
                        <button
                          type="submit"
                          className="px-4 py-1.5 text-white text-sm font-medium bg-green-500 hover:bg-green-600 rounded"
                        >
                          ویرایش کردن
                        </button>
                      </div>
                    </form>
                  </div>
                </div>
              </div>
            )}
          </div>
        </div>
      </div>
    </>
  );
};

export default AdminDashboardNews;
